export function isPageActive(
    module: string,
    client: any,
    permissions: any,
): string {
    if (client) {
        const permissions_client = permissions?.data?.website_main?.items;
        if (permissions_client) {
            const item = permissions_client.find(
                (p: { module: string; label: string }) => p.module === module,
            );
            return item?.label;
        }
    }
    return "";
}
